// src/components/Header.js - Updated with improved mobile menu functionality
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import env from '../config/env'; // Import environment config

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle route changes
  useEffect(() => {
    // Close mobile menu when route changes
    closeMobileMenu();
  }, [location.pathname]);

  // Handle menu body locking when menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      // Prevent body scrolling when menu is open
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    
    // Cleanup function
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // Handle escape key press to close menu
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && mobileMenuOpen) {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => document.removeEventListener('keydown', handleEscKey);
  }, [mobileMenuOpen]);

  // Handle clicking outside of menu to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close menu when clicking outside (but not on the toggle button)
      if (mobileMenuOpen && 
          !event.target.closest('.main-nav') && 
          !event.target.closest('.mobile-menu-toggle')) {
        closeMobileMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [mobileMenuOpen]);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo-container">
          <Link to="/" onClick={closeMobileMenu}>
            {/* Use the regular logo URL from the env config */}
            <img 
              src={env.logoUrl} 
              alt="Legate" 
              className="logo"
            />
          </Link>
        </div>

        <nav className={`main-nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/about" 
                className={location.pathname === '/about' ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/services" 
                className={location.pathname === '/services' ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                Services
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/blog" 
                className={location.pathname.includes('/blog') ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                Blog
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/downloads" 
                className={location.pathname === '/downloads' ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                Resources
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/collaboration" 
                className={location.pathname === '/collaboration' ? 'active' : ''} 
                onClick={closeMobileMenu}
              >
                Collaboration
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/service-form" 
                className={`${location.pathname === '/service-form' || location.pathname === '/start-now' ? 'active' : ''} btn-nav`}
                onClick={closeMobileMenu}
              >
                Start Now
              </Link>
            </li>
          </ul>
        </nav>

        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  );
};

export default Header;
